<template>
  <div>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="splitConfigurations"
        :loading="isLoading"
        :no-data-text="$t('table.noResults')"
        :loading-text="$t('table.loading')"
        :items-per-page="itemsPerPage"
        mobile-breakpoint="20"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.vendor`]="{ item }">
          {{ item.name ? item.name : '---' }}
        </template>
        <template v-slot:[`item.host_take_rate`]="{ item }">
          {{ splitMode(item.host_take_rate, item.host_take_rate_mode) }}
        </template>
        <template v-slot:[`item.customer_take_rate`]="{ item }">
          {{ splitMode(item.customer_take_rate, item.customer_take_rate_mode) }}
        </template>
        <template v-slot:[`item.hauseful_take_rate`]="{ item }">
          {{ splitMode(item.hauseful_take_rate, item.hauseful_take_rate_mode) }}
        </template>
        <template v-slot:[`item.partner_take_rate`]="{ item }">
          {{ splitMode(item.partner_take_rate, item.partner_take_rate_mode) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-end">
            <v-btn
              @click="showSplitConfigurationDetails(item.id)"
              class="mx-1"
              small
              icon
            >
              <v-icon small> mdi-eye </v-icon>
            </v-btn>

            <!-- <v-btn
              @click="createEditSplitConfiguration(item.id)"
              class="mx-1"
              small
              icon
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn> -->

            <v-btn
              @click="handleDeleteSplitConfigurationItemModal(item.id)"
              class="mx-1"
              small
              icon
            >
              <v-icon small> mdi-delete </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <SplitConfigurationDelete />
    <SplitConfigurationCreateEdit ref="createSplitConfiguration" />
    <RightDrawer :moreInfo="false">
      <SplitConfigurationDetails />
    </RightDrawer>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { splitConfigurationHeaders } from '@/views/split/listHeaders'
import { splitMode } from '@/views/split/utils'

import RightDrawer from '@/components/app/RightDrawer'
import SplitConfigurationDelete from '@/views/split/components/SplitConfigurationDelete'
import SplitConfigurationDetails from '@/views/split/components/SplitConfigurationDetails'
import SplitConfigurationCreateEdit from '@/views/split/components/SplitConfigurationCreateEdit'

export default {
  name: 'SplitConfigurationList',

  components: {
    RightDrawer,
    SplitConfigurationDelete,
    SplitConfigurationDetails,
    SplitConfigurationCreateEdit,
  },

  data() {
    return {
      splitMode,
      headers: splitConfigurationHeaders,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'splitConfigurations', 'itemsPerPage']),
  },

  methods: {
    ...mapActions([
      'fetchSplitConfiguration',
      'fetchSplitConfigurations',
      'handleOpenCreateEditSplitConfigurationModal',
      'handleDeleteSplitConfigurationItemModal',
    ]),

    ...mapMutations(['setIsDrawerOpen']),

    showSplitConfigurationDetails(id) {
      this.fetchSplitConfiguration(id)
      this.setIsDrawerOpen(true)
    },

    createEditSplitConfiguration(id) {
      this.$refs?.createSplitConfiguration?.resetForm()
      this.handleOpenCreateEditSplitConfigurationModal(id)
    },
  },

  mounted() {
    this.fetchSplitConfigurations()
  },
}
</script>
